module.exports = function() {
  return new Worker(__webpack_public_path__ + "82098f9e9040b733d6f9.worker.js");
};